// @ts-strict-ignore
const authorize = (userRoles, authorizationRoles) => {
	const sanitizedUserRoles = userRoles.map((role) => {
		if (typeof role !== "string") {
			return role.name;
		}

		return role;
	});

	if (typeof authorizationRoles === "string") {
		return sanitizedUserRoles.includes(authorizationRoles);
	}

	let result = false;

	for (let i = 0; i < authorizationRoles.length; i += 1) {
		const authorizationRole = authorizationRoles[i];

		const tempResult = sanitizedUserRoles.includes(authorizationRole);

		if (tempResult) {
			result = tempResult;
			break;
		}
	}

	return result;
};

const authorizationRoles = {
	BASIC: "Basic" as const,
	ADMIN: "Admin" as const,
	COMPANY: "Company" as const,
	CONTRIBUTOR: "Contributor" as const,
	PREMIUMSUBSCRIBER: "PremiumSubscriber" as const,
	MARKETEER: "Marketeer" as const,
	SUPERADMIN: "SuperAdmin" as const,
	RESEARCHMANAGER: "ResearchManager" as const
};

const authorizationRolesIds = {
	Basic: 1,
	Admin: 2,
	Company: 3,
	PremiumSubscriber: 6,
	Marketeer: 7,
	SuperAdmin: 9,
	ResearchManager: 10
};

export { authorize, authorizationRoles, authorizationRolesIds };
